import { useState, useEffect, useCallback } from "react";
import { trendDataService, TrendDataFilters, TrendDataResponse } from "../services/trend-data.service";

export interface UseTrendDataReturn {
  data: TrendDataResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  isInitialLoading: boolean;
}

export const useTrendData = (filters: TrendDataFilters): UseTrendDataReturn => {
  const [data, setData] = useState<TrendDataResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const result = await trendDataService.fetchTrendData(filters);
      setData(result);
      
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to fetch trend data";
      setError(errorMessage);
      console.error("Error fetching trend data:", err);
    } finally {
      setLoading(false);
      setIsInitialLoading(false);
    }
  }, [filters]);

  const refetch = useCallback(async () => {
    await fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refetch,
    isInitialLoading
  };
};
